<div class="modal-header">
    <h4 class="modal-title">Puantaj {{data.row ? 'Güncelle' : 'Ekle'}}</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="personPointForm">
        <div class="form-group">
            <label>Tür</label>
            <ng-select [items]="statusList" formControlName="status" bindLabel="name" bindValue="id"
                placeholder="Durum Seç"></ng-select>
        </div>

        <div class="form-group">
            <label>Mesai Tarihi</label>
            <ng2-flatpickr [config]="dateTimeOptions" formControlName="workDate" [setDate]="date"></ng2-flatpickr>
        </div>

        <div class="form-group col-12">
            <label>Mesai Türü</label>
            <div class="form-check-group row justify-content-between">
                <div class="form-check">
                    <input class="form-check-input" type="radio" formControlName="dayType" value="full"
                        (change)="onDayTypeChange()" /> Tam Gün
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" formControlName="dayType" value="half"
                        (change)="onDayTypeChange()" /> Yarım Gün
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" formControlName="dayType" value="manual"
                        (change)="onDayTypeChange()" /> Manuel
                    Giriş
                </div>
            </div>
        </div>

        <div class="form-group row col-12">
            <div class="col-md-6">
                <label>Başlangıç Saati</label>
                <ngb-timepicker [formControl]="personPointForm.get('startTime')"></ngb-timepicker>
            </div>
            <div class="col-md-6">
                <label>Bitiş Saati</label>
                <ngb-timepicker [formControl]="personPointForm.get('endTime')"></ngb-timepicker>
            </div>
        </div>


        <div class="form-group">
            <label>Açıklama</label>
            <textarea class="form-control" formControlName="description"></textarea>
        </div>
    </form>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">İptal</button>
    <button type="button" class="btn btn-success" [disabled]="!isFormValid()" (click)="onSumbit()">{{data.row ?
        'Güncelle' : 'Kaydet'}}</button>
</div>